import React, { useState } from "react";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import {
  __ConvertirABase64,
  __DescargarArchivo,
} from "../../../Utils/Funciones";
import ServicioComun from "../../../servicios/Comun";
import ServicioSolicitudDePadron from "../../../servicios/SolicitudDePadron";

export default function Documentos({
  Documentos,
  EsEditable,
  onChangeDocumentos,
}) {
  const [archivosSeleccionados, setArchivosSeleccionados] = useState([]);

  const handleFileInput = async (e, documento) => {
    const archivo = e.target.files[0];
    const archivoBase64 = await __ConvertirABase64(archivo);

    documento.nombreArchivo = archivo.name;
    documento.archivoBase64 = archivoBase64.split(",")[1];

    const resultadoValidacion = await ServicioComun.ValidarSubidaDeDocumento([
      documento,
    ]);
    if (!resultadoValidacion.esValido) {
      Notificar("error", resultadoValidacion.errores);
      return;
    }

    ActualizarArchivosSeleccionados(documento);
  };

  const ActualizarArchivosSeleccionados = (documento) => {
    let archivos = [...archivosSeleccionados];
    const index = archivos.findIndex(
      (x) => x.tipoDocumento.codigo === documento.tipoDocumento.codigo
    );
    index === -1 ? archivos.push(documento) : (archivos[index] = documento);

    setArchivosSeleccionados(archivos);
    onChangeDocumentos(archivos);
  };

  const DescargarDocumento = async (documento) => {
    CerrarNotificador();

    let resultado =
      await ServicioSolicitudDePadron.DocumentoDetalleSolicitudesPadron(
        documento
      );

    if (!resultado.Documento) {
      Notificar(
        "error",
        "Ha ocurrido un error intentando obtener el documento"
      );
      return;
    }

    __DescargarArchivo(resultado.Documento, resultado.NombreArchivo);
  };

  return (
    <div id="Documentos" className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Documentos</h6>
      </div>
      <div className="card-body">
        <table id="tbDocumentos" className="table table-sm">
          <thead className="table-primary">
            <tr>
              <th>Nombre </th>
              <th>Tipo Documento</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {Documentos.map((item, index) => (
              <tr key={index}>
                <td>{item.nombreArchivo}</td>
                <td>{item.tipoDocumento.descripcion}</td>
                <td className="w-25">
                  {EsEditable ? (
                    <label className="btn btn-light">
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) => handleFileInput(e, item)}
                      />
                      <i className="fas fa-upload text-primary mr-2"></i>
                      Subir archivo
                    </label>
                  ) : (
                    <button
                      className="btn btn-primary btn-sm"
                      title="Descargar Documento"
                      onClick={() => DescargarDocumento(item)}
                    >
                      <span className="icon">
                        <i className="fas fa-download"></i>
                      </span>
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
